import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IdentityUser } from '../models/user.model';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, tap, catchError, throwError, Observable, BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'any' })
export class AuthApiService {
  private _baseUrl: string = environment.S2EMULATOR_API_ENDPOINT;
  private _userSubject = new BehaviorSubject<IdentityUser | null>(null);

  private _oidcSecurityService = inject(OidcSecurityService);
  private http = inject(HttpClient);

  getSelf() {
    return this.http.get<IdentityUser>(`${this._baseUrl}/auth/self`);
  }

  updateProfile(profile: any) {
    return this.http.put(`${this._baseUrl}/auth/profile`, {
      firstName: profile.firstName,
      lastName: profile.lastName,
      email: profile.email,
      phone: profile.phone,
      avatar: profile.avatar,
      bio: profile.bio,
    });
  }

  loginWithIAM() {
    this._oidcSecurityService.authorize();
  }

  logout() {
    this._oidcSecurityService.logoff().subscribe();
  }

  logoutFromIdentity() {
    return this.http.post<void>(`${this._baseUrl}/auth/logout`, {}, {
      headers: { skipErrorHandling: 'true' }
    });
  }

  loginWithIdentity(username: string, password: string): Observable<IdentityUser> {
    return this.http
      .post<IdentityUser>(
        `${this._baseUrl}/auth/login`,
        { username, password },
        {
          headers: {
            skipAuth: 'true',
            'Content-Type': 'application/json',
          },
          observe: 'response',
        }
      )
      .pipe(
        map((response) => {
          if (!response.body) {
            throw new Error('Login response has no body');
          }
          return response.body;
        }),
        tap((user) => {
          this._userSubject.next(user);
          localStorage.setItem(environment.USER_KEY, JSON.stringify(user));
        }),
        catchError((error) => {
          console.error('Login failed', error);
          return throwError(() => error);
        })
      );
  }

  downloadProfile() {
    return this.http.get(`${this._baseUrl}/auth/download-profile`);
  }

  deleteAccount() {
    return this.http.delete(`${this._baseUrl}/auth`)
  }
}
